import { TOP_ID } from '@/constant/index'
import { store } from '@/store'
import { API_CENTER_DICTIONARY } from '@/api/center'
import { defineStore } from 'pinia'
import { toTree, deepClone } from '@bd/vue3-utils'
interface DictItem {
  label: string
  code: string
  value: string
  pValue: string
  params?: any
}
declare type DictType = DictItem[]

interface DictState {
  category: Map<string, DictType>
  tree: Map<string, (DictItem & { childrens: DictType })[]>
  word: Map<string, DictItem>
}
export const useDictStore = defineStore({
  id: 'dict',
  state: (): DictState => ({
    /** 类目 */
    category: new Map(),
    /** 树状 */
    tree: new Map(),
    /** 词 */
    word: new Map()
  }),
  actions: {
    _setCategory(data: DictItem) {
      this.category.set(data.code, [...(this.category?.get(data.code) ?? []), data])
    },
    _setWord(data: DictItem) {
      this.word.set(data.value, data)
    },
    /**
     * 格式化接口返回数据
     */
    _setData(data: ApiCenter.DictionaryRes) {
      const idMap = new Map<string, ApiCenter.DictionaryRes[0]>()
      data.forEach(item => {
        idMap.set(item.id!, item)
      })
      return data.map(item => {
        const _res = {
          label: item.dictionaryValue,
          code: item.dictionaryCode,
          value: item.dictionaryKey,
          pValue: idMap.get(item.parentCode)?.dictionaryKey ?? TOP_ID,
          params: item.parameterJson ? JSON.parse(item.parameterJson) : undefined
        }
        if (item.parentCode !== TOP_ID) this._setCategory(_res)
        this._setWord(_res)
        return _res
      })
    },
    reset() {
      this.category.clear()
      this.tree.clear()
      this.word.clear()
    },
    async init() {
      this.reset()
      const dictRes = await API_CENTER_DICTIONARY()
      const _dictRes = this._setData(dictRes)
      const treeDict = toTree({
        data: deepClone(_dictRes),
        idName: 'value',
        parentIdName: 'pValue',
        childrenName: 'childrens'
      })
      treeDict.forEach(i => {
        if (!this.tree.has(i.code)) this.tree.set(i.code, i.childrens)
      })
    }
  }
})
// Need to be used outside the setup
export function useDictStoreOutside() {
  return useDictStore(store)
}
